import {createAction} from "redux-act";
import {ILadder} from "modules/types";

export const fetchTeamLadderAction = createAction();
export const fetchTeamLadderSuccess = createAction<ILadder>();
